/* 
	该文件专门为组件生成action对象
*/

import { ADD_BREADCRUMBER, REDUCE_BREADCRUMBER, REPLACE_BREADCRUMBER } from "../../config/constant"

export const replaceBreadcrumber = (data) => { return { type: REPLACE_BREADCRUMBER, data } }
export const addBreadcrumber = (data) => { return { type: ADD_BREADCRUMBER, data } }
export const reduceBreadcrumber = (data) => { return { type: REDUCE_BREADCRUMBER, data } }